module.exports = __webpack_public_path__ + "src/assets/img/engine_six_color.82f167a9.svg";